import { render, staticRenderFns } from "./OravitaAnina.vue?vue&type=template&id=1d96bd09&"
import script from "./OravitaAnina.vue?vue&type=script&lang=js&"
export * from "./OravitaAnina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports